import BrowserLogger from 'alife-logger'
import pkg from '../package.json'

export default async () => {
  console.log('当前环境===', process.env.CURRENT_MODE)
  if (process.env.CURRENT_MODE === 'production') {
    const __bl = BrowserLogger.singleton({
      pid: 'a89dbz1x85@306f1cf128954b6',
      // 设定日志上传地址：
      // 部署新加坡地域可设为`https://arms-retcode-sg.aliyuncs.com/r.png?`。
      // 部署美西地域可设为`https://retcode-us-west-1.arms.aliyuncs.com/r.png?`。
      imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
      appType: 'web',
      sendResource: true,
      enableLinkTrace: true,
      behavior: true,
      release: pkg.version,
      ignore: {
        //https://help.aliyun.com/document_detail/58655.htm?spm=a2c4g.11186623.0.0.3fd8558c25rjVD#sc-ignore
        ignoreErrors: ["undefined is not an object (evaluating 'r['@context'].toLowerCase')", /^Script error\.?$/]
      }
    })
  }
}
